import React from "react"

export default function BranchOptions({item}) {
  if (item.org)
    return (
      <div className="d-flex justify-content-between">
        <div>
          {item.org.companyName} {item.org.branchName}
        </div>
        <div>{item.org.fullCode}</div>
      </div>
    )
  return <span>{item.label}</span>
}
